<template>
<!-- 
    * Copyright: T-Systems México S.A. de C.V.
    * Descripción: Vista atributos, permite consultar, crear, editar y eliminar atributos disponibles 
    * Autor: 
    * F.Creación: 
  -->
  <layout :title="$t('moduleTitle')">
    <!-- Contenido -->
    <template v-slot:content>
      <!-- modal con formulario para la creacion de nuevo atributo -->
      <v-dialog persistent v-model="newDialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            {{$t("tblbutton")}}
            <v-spacer></v-spacer>
            <v-btn icon color="grey" @click="dialogHelp = true">
              <v-icon>mdi-help-circle-outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="newForm" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-select
                      v-model="selected"
                      :label="$t('lblAttribute')"
                      :items="checkbox_options"
                    ></v-select>
                    <!-- <strong>{{ selected }}</strong> -->
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :rules="nameRules"
                      :counter="40"
                      v-model="currentatributtes.name"
                      :label="$t('lblName')"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      :rules="descriptionRules"
                      :counter="80"
                      v-model="currentatributtes.description"
                      :label="$t('lblDescription')"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="selected==2">
                  <v-col cols="6">
                    <v-text-field
                      :rules="minValueRules"
                      :counter="2"
                      v-model="currentatributtes.minValue"
                      :label="$t('lblMinValue')"
                      :disabled="selected !=2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      :rules="maxValueRules"
                      :counter="3"
                      v-model="currentatributtes.maxValue"
                      :label="$t('lblmMxValue')"
                      :disabled="selected !=2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <p class="caption error--text" v-html="errorMessage"></p>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeNewDialog()">{{$t("mdlCancel")}}</v-btn>
            <v-btn text @click.stop="doNewDialog()" color="primary">{{$t("mdlSave")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
       <!-- modal con formulario para la edicion de un atributo -->
      <v-dialog persistent v-model="uploadDialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("dlgUploadTitle")}}</v-card-title>

          <v-card-text>
            <v-container>
              <v-form ref="newMapForm" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="currentatributtes.name" :label="$t('lblName')"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="currentatributtes.description"
                      :label="$t('lblDescription')"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="currentatributtes.attributeType == 2">
                  <v-col cols="6">
                    <v-text-field v-model="currentatributtes.minValue" :label="$t('lblMinValue')"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model="currentatributtes.maxValue" :label="$t('lblmMxValue')"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <p class="caption error--text" v-html="errorMessage"></p>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeUploadDialog()">{{$t("mdlCancel")}}</v-btn>
            <v-btn text @click.stop="doUploadDialog()" color="primary">{{$t("mdlSave")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        <!-- Formulario para confirmar la eliminacion de un atributo -->
      <v-dialog persistent v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("dlgDeleteMapTitle")}}</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-alert outlined type="warning" prominent border="left">
                    {{$t('lbldelete1')}}
                    <br />
                    <strong>{{currentatributtes.name}}</strong>
                    <!-- <strong>{{currentatributtes.id}}</strong> -->
                    <br />{{$t('lbldelete2')}}
                  </v-alert>
                </v-col>
                <v-col cols="12">
                  <p class="caption error--text" v-html="errorMessage"></p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeDeleteDialog()">{{$t("mdlCancel")}}</v-btn>
            <v-btn text @click.stop="doDeleteDialog()" color="primary">{{$t("mdlSave")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        <!-- Formulario con seccion de ayuda para creacion de atributos -->
      <v-dialog v-model="dialogHelp" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t('helpTitle')}}</v-card-title>

          <v-card-text class="text-justify">
            {{$t('helpText')}}
            <ol>
              <li>{{$t('helpList1')}}</li>
              <li>{{$t('helpList2')}}</li>
              <li>{{$t('helpList3')}}</li>
            </ol>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogHelp = false">{{$t("mdlSave")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- caja de texto para buscar informacion en tabla de contenido -->
      <v-text-field
        solo
        class="mt-4"
        :label="$t('headerSearch')"
        prepend-inner-icon="mdi-account"
        v-model="search"
      ></v-text-field>
      <!-- Tabla de contenido -->
      <v-data-table
        :headers="headers"
        :items="atributtes"
        :loading="isLoading"
        :search="search"
        loading-text="Cargando elementos en tabla"
        color="primary"
      >
        <template v-slot:top>
          <v-toolbar flat color="primary">
            <v-toolbar-title class="white--text">{{$t('tblTitle')}}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical color="white"></v-divider>
            <v-col
              cols="12"
              sm="2"
            >
               <v-select
                v-model="filterType"
                :items="itemTypes"
                item-value="id"
                item-text="name"
              ></v-select>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              @click.stop="newDialog = true"
            >{{$t('tblbutton')}}</v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.minVal="{ item }">
          <v-col v-if="item.minValue ==0">
            <v-row>
              <p>-</p>
            </v-row>
          </v-col>
          <v-col v-else>{{item.minValue}}</v-col>
        </template>
        <template v-slot:item.maxVal="{ item }">
          <v-col v-if="item.maxValue ==0">
            <v-row>
              <p>-</p>
            </v-row>
          </v-col>
          <v-col v-else>{{item.maxValue}}</v-col>
        </template>
        <!-- Panel de acciones -->
        <template v-slot:item.action="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon class="mr-2" color="grey" v-on="on" @click="showUploadDialog(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>{{$t('lblEdit')}}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon class="mr-2" color="grey" v-on="on" @click="showDeleteDialog(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>{{$t('lblDelete')}}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-snackbar v-model="snackbar">
        {{ mensaje }}
        <v-btn color="primary" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </template>
  </layout>
</template>

<script>
// Incluimos el LAYOUT estandar para los usuario que ya tienen
// una sesión activa
import Layout from "@/components/Layouts/company";
// Incluimos los mensajes de esta pantalla
import i18nMessages from "./i18n.messages";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  // Se definen los componentes requeridos por esta pantalla
  components: {
    layout: Layout
  },
  created() {
    this.$i18n.locale = this.locale;
    // Obtenemos la lista de atributos
    this.loadData(1);
    //inicializamos encabezados de la tabla
    this.updateHeadersLocale();
  },
  beforeDestroy() {},
  i18n: i18nMessages,
  data: function() {
    return {
      // Se utilizan como banderas (FLAG) para
      // los cuadros de dialogo
      newDialog: false,
      deleteDialog: false,
      uploadDialog: false,
      viewDialog: false,
      dialogHelp: false,
      selected: null,
       //variables  para control de validaciones
      snackbar: false,
      mensaje: "",
      search: "",
      loading: true,
      dialog: false,
      // Tipos de item
      itemTypes: [
        {id: 1, name: "Salas de juntas"},
        {id: 2, name: "Autos"},
        {id: 3, name: "Bicicletas"},
      ],
      filterType: 1,
      //arreglo para almacenar los atributos
      atributtes: [],
      //arreglo para almacenar cambios de atributos
      currentatributtes: {  },
      errorMessage: "",
      //validaciones de formularios
      nameRules: [
        v => v.length < 40 || "El nombre de un atributo no puede exceder los 40 caracteres",
      ],
      descriptionRules:[
        v => v.length < 80 || "El nombre de un atributo no puede exceder los 80 caracteres",
      ],
      minValueRules:[
 v => v.length < 3 || "el valor minimo no puede exceder los 2 caracteres",
      ],
      maxValueRules:[
         v => v.length < 4 || "el valor maximo no puede exceder los 3 caracteres",
      ],
      //encabezados de la tabla
      headers: [
        { id: "headerName", text: "Nombre", value: "name" },
        { id: "headerDescription", text: "Descripcion", value: "description" },
        //{ id:'', text: "tipo de atributo", value: "attributeType" },
        {
          id: "headerMinVal",
          text: "Valor minimo",
          value: "minVal",
          sortable: true
        },
        {
          id: "headerMaxVal",
          text: "Valor maximo",
          value: "maxVal",
          sortable: true
        },
        {
          id: "headerAction",
          text: "Acciones",
          value: "action",
          sortable: false
        }
      ],
      checkbox_options: [
        { value: 1, text: "TIENE/NO TIENE" },
        { value: 2, text: "CANTIDAD" },
        { value: 6, text: "DESCRIPCIÓN" }
      ]
    };
  },
  mounted: () => {},
  computed: {
    ...mapGetters(["isLoading"]),
    locale() {
      return this.$store.getters["locale"];
    }
  },
  watch: {
    locale(value) {
      this.$i18n.locale = value;
      this.updateHeadersLocale();
    },
    filterType (val) {
      this.loadData(val);
    },
  },
  methods: {
    setCurrentAttrib(item) {
      //Realizamos una copia del objeto atributo
      //utilizan el método clone de la utileria LODASH
      this.currentatributtes = _.clone(item);
    },
    // Actualiza el idioma de los encabezados de la tabla
    updateHeadersLocale() {
      this.headers = this.headers.map(header => {
        header.text = this.$t(header.id);
        return header;
      });
    },
    //consulta de atributos desde lambda, asignacion de datos a arreglo atributo
    loadData(itemType) {
      //** console.log("invocaion loadData");
      let settings = {
        itemTypeId: itemType
      };
      this.$GET("/api/itemTypes/{{itemTypeId}}/attributes", settings)
        .then(atributtes => {
          this.atributtes = atributtes.map(item => {
            return {
              id: item.id,
              lastUpdate: item.lastUpdate,
              updatedBy: item.updatedBy,
              itemTypeId: item.itemTypeId,
              attributeType: item.attributeType,
              minValue: item.minValue,
              maxValue: item.maxValue,
              name: item.name,
              description: item.description
            };
          });
          //** console.log("atributtes: ", this.atributtes);
        })
        .catch(() => { 
          //** console.log(e)
        });
    },
    //cearrar modal con formulario para crear nuevo atributo
    closeNewDialog() {
      this.newDialog = false;
      this.$refs.newForm.reset()
      this.currentatributtes = {  };
      this.$refs.newForm.reset();
      this.errorMessage = "";
    },
    //proceso de creacion de nuevo atributo
    doNewDialog() {
      if (this.selected == null) {
        this.snackbar = true;
        this.mensaje =
          "debes de seleccionar el tipo de atributo de forma obligatoria";
      } else if(this.currentatributtes.name == null){
          this.snackbar = true;
        this.mensaje =
          "El nuevo atributo debe de tener un nombre de forma obligatoria";
      } else if(this.selected == 2 && (this.currentatributtes.minValue == null || this.currentatributtes.maxValue == null)){
        this.mensaje =
          "Los atributos tipo CANTIDAD deben de tener un balos maximo y minimo de forma obligatoria";
      }else {
        let payload = {
          data: {
            itemTypeId: this.filterType,
            attributeType: this.selected,
            minValue: this.selected == 2 ? this.currentatributtes.minValue : 0,
            maxValue: this.selected == 2 ? this.currentatributtes.maxValue : 0,
            name: this.currentatributtes.name,
            description: this.currentatributtes.description == null ? " " : this.currentatributtes.description
          }
        };
        //** console.log("/api/attributes", payload);
        this.$POST("/api/attributes", payload)
          .then( () => {
            //** console.log(response);
            this.loadData(this.filterType);
            this.newDialog = false;
            this.errorMessage = "";
          })
          .catch(() => {
            // En caso de error presentar un mensaje
            // al usuario
            //** console.log(e);
            this.errorMessage = "Ocurrió un error al crear el Atributo";
          })
          .finally(() => {});
      }
    },
    //mostrar modal para la edicion de atributo
    showUploadDialog(item) {
      //this.currentatributtes = item;
      this.setCurrentAttrib(item);
      this.uploadDialog = true;
    },
    //cerrar modal para la edicion de atributo
    closeUploadDialog() {
      this.uploadDialog = false;
      this.currentatributtes = { resource: {} };
      
      this.errorMessage = "";
    },
    //iniciar proceso de edicion de atributo
    doUploadDialog() {
      let payload = {
        params: {
          attributeId: this.currentatributtes.id
        },
        data: {
          itemTypeId: this.currentatributtes.itemTypeId,
          attributeType: this.currentatributtes.attributeType,
          minValue: this.currentatributtes.minValue,
          maxValue: this.currentatributtes.maxValue,
          name: this.currentatributtes.name,
          description: this.currentatributtes.description,
          lastUpdate: this.currentatributtes.lastUpdate
        }
      };
      //** console.log("/api/attributes/{{attributeId}}", payload);
      this.$PUT("/api/attributes/{{attributeId}}", payload)
        .then( () => {
          //** console.log(response);
          this.loadData(this.filterType);
          this.uploadDialog = false;
        })
        .catch(() => {
          // En caso de error presentar un mensaje
          // al usuario
          //** console.log(e);
          this.errorMessage = "Ocurrió un error al editar el atributo";
        })
        .finally(() => {});
    },
    //mostrar modal para eliminar un atributo
    showDeleteDialog(item) {
      this.currentatributtes = item;
      this.deleteDialog = true;
    },
    //cerrar modal para eliminar atributo
    closeDeleteDialog() {
      this.deleteDialog = false;
      this.currentatributtes = { resource: {} };
      this.errorMessage = "";
    },
    //proceso para eliminar un atributo
    doDeleteDialog() {
      let payload = {
        params: {
          attributeId: this.currentatributtes.id
        },
        data: {
          lastUpdate: this.currentatributtes.lastUpdate
        }
      };
      //** console.log("/api/attributes/{{attributeId}}", payload);
      this.$DELETE("/api/attributes/{{attributeId}}", payload)
        .then( () => {
          //** console.log(response);
          this.loadData(this.filterType);
          this.closeDeleteDialog();
          this.errorMessage = "";
        })
        .catch(() => {
          // En caso de error presentar un mensaje
          // al usuario
          this.currentatributtes = { resource: {} };
          //** console.log(e);
          this.errorMessage = "Ocurrió un error al eliminar atributo";
        })
        .finally(() => {});
    }
  }
};
</script>